import { useSeoMeta } from "@unhead/react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getPostBySlug } from "@/lib/blog-posts";

const BlogPostPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getPostBySlug(slug) : undefined;

  useSeoMeta({
    title: "Let's Talk",
    description: "",
  });

  if (!post) {
    return (
      <div className="min-h-screen pt-32 pb-20 bg-[#0a0a0a]">
        <div className="container mx-auto px-4 max-w-3xl text-center">
          <Link
            to="/blog"
            className="group text-white font-semibold flex items-center gap-2 justify-center"
          >
            <ArrowLeft className="transition-transform group-hover:-translate-x-1" size={20} />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-32 pb-20 bg-[#0a0a0a]">
      <div className="container mx-auto px-4 max-w-3xl">
        <Link
          to="/blog"
          className="group text-neutral-400 hover:text-white font-semibold flex items-center gap-2 mb-8"
        >
          <ArrowLeft className="transition-transform group-hover:-translate-x-1" size={20} />
        </Link>
      </div>
    </div>
  );
};

export default BlogPostPage;
